import { ErrorMessage, Field } from 'formik'
import './inputWithoutBorder.scss'

const InputWithoutBorder = ({
  inputTitle,
  inputFieldclass,
  titleClass,
  placeholder,
  name,
  children,
  onFocus,
  required,
}) => {
  return (
    <>
      <div className='module-name-div'>
        <span className={`field-titles ${titleClass}`}>{inputTitle}</span>
        <span className='without-bordered-required'>{required ? '*' : ''}</span>
        <Field
          type='text'
          name={name}
          className={`add-modal-name-input ${inputFieldclass}`}
          placeholder={placeholder}
          onFocus={onFocus}
          maxLength={100}
        />
        {children}
      </div>
      <ErrorMessage name={name} component='div' className='error-msg' />
    </>
  )
}

export default InputWithoutBorder
